import { FC } from 'react'
import Page from '@/client/submodules/Page'
import { Featured } from './Featured'
import { ShippingCosts } from './ShippingCosts'
import { ShippingOptionsProps } from './types'

export const ShippingOptions: FC<ShippingOptionsProps> = ({
  seo,
  header,
  footer,
  content: { breadcrumb, title, subtitle, shipping_options, description, relevant_links }
}) => (
  <Page seo={seo} header={header} footer={footer}>
    <Featured breadcrumb={breadcrumb} title={title} subtitle={subtitle} />
    <ShippingCosts shipping_options={shipping_options} description={description} relevant_links={relevant_links} />
  </Page>
)
